export enum SignatureModelType {

    SignatureImage = 0,
    FieldsPosition = 1,
}